import { IJob } from '~/domain/Jobs';

/**
 * Id of the professional's counter-offer (the "offer") on a given job.
 *
 * The bulk confirm page lists one professional against N of their pending offers,
 * so the offer id has to be resolved per job — mirroring the lookup
 * `bulkConfirmAdapter` performs when building the confirm request, and what
 * ShiftItem uses to render counter rates/hours (GOTU-4815).
 */
export const getCandidateOfferId = (
  job: IJob | undefined,
  candidateId: string | undefined,
): string | undefined => {
  // Bail on a missing id rather than matching it: a counter with no candidate would
  // otherwise satisfy `undefined === undefined` and return the wrong offer.
  if (!candidateId) {
    return undefined;
  }

  return job?.multipleCounters?.find(({ candidate }) => candidate?.id === candidateId)?.id;
};
